import React, { useState } from 'react';
import { X } from 'lucide-react'; // Using Lucide-React for the close icon

const NewChatbotModal = ({ isOpen, onClose, onCreateChatbot }) => {
  // Mock data for dropdowns - in a real app, this would come from props or an API
  const availableKeys = [
    { id: 'key1', name: 'Personal Key (sk-...1234)' },
    { id: 'key2', name: 'Work Key (sk-...5678)' },
  ];
  const availableModels = ['gpt-4o', 'gpt-4-turbo', 'gpt-3.5-turbo'];

  // State for the form fields
  const [chatbotName, setChatbotName] = useState('');
  const [selectedKey, setSelectedKey] = useState('');
  const [selectedModel, setSelectedModel] = useState(availableModels[0]); // Default to the first model

  const handleSubmit = (e) => {
    e.preventDefault();
    // Pass the new chatbot data to the parent component
    onCreateChatbot({
      name: chatbotName,
      openaiKey: selectedKey,
      model: selectedModel,
    });
    // Clear the form and close the modal
    setChatbotName('');
    setSelectedKey('');
    setSelectedModel(availableModels[0]);
    onClose(); // This would likely be called after a successful API call
  };

  // Don't render the modal if it's not open
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-800 bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-5 border-b border-slate-100">
          <h3 className="text-xl font-semibold text-slate-800">New chatbot</h3>
          <button
            onClick={onClose}
            className="text-slate-800 hover:text-slate-600 transition-colors"
            aria-label="Close modal"
          >
            <X size={24} />
          </button>
        </div>

        {/* Modal Body (Form) */}
        <form onSubmit={handleSubmit} className="p-5 space-y-5">
          {/* Chatbot Name Field */}
          <div>
            <label htmlFor="chatbotName" className="block text-slate-800 text-sm font-medium mb-1">
              Name chatbot name
            </label>
            <input
              type="text"
              id="chatbotName"
              value={chatbotName}
              onChange={(e) => setChatbotName(e.target.value)}
              className="w-full p-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 text-slate-800 bg-slate-100"
              placeholder="e.g., Customer Support Bot"
              required
            />
          </div>

          {/* OpenAI Key Selection */}
          <div>
            <label htmlFor="openaiKey" className="block text-slate-800 text-sm font-medium mb-1">
              OpenAI key
            </label>
            <select
              id="openaiKey"
              value={selectedKey}
              onChange={(e) => setSelectedKey(e.target.value)}
              className="w-full p-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 text-slate-800 bg-slate-100 appearance-none"
              required
            >
              <option value="" disabled>Select a key</option>
              {availableKeys.map(key => (
                <option key={key.id} value={key.id}>{key.name}</option>
              ))}
            </select>
          </div>

          {/* ChatGPT Model Selection */}
          <div>
            <label htmlFor="chatgptModel" className="block text-slate-800 text-sm font-medium mb-1">
              ChatGPT model used
            </label>
            <select
              id="chatgptModel"
              value={selectedModel}
              onChange={(e) => setSelectedModel(e.target.value)}
              className="w-full p-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 text-slate-800 bg-slate-100 appearance-none"
              required
            >
              {availableModels.map(model => (
                <option key={model} value={model}>{model}</option>
              ))}
            </select>
          </div>

          {/* Modal Footer (Create Button) */}
          <div className="pt-4">
            <button
              type="submit"
              className="w-full bg-blue-500 text-white font-semibold py-3 px-6 rounded-md hover:bg-blue-600 transition-colors shadow-md"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewChatbotModal;
